import { TablePaginationConfig } from "antd";
import { placesApi } from "api/place";
import { useDataLoadingContext } from "contexts/DataLoadingContext";
import { useNotificationContext } from "contexts/NotificationContext";
import { defaultTableData, ITableData } from "models";
import { IPlace } from "models/place";
import { ChangeEvent, useEffect, useState } from "react";

export default function usePlace() {
  const { showError } = useNotificationContext();
  const { reloadPlace } = useDataLoadingContext();
  const [data, setData] = useState<ITableData<IPlace>>(defaultTableData);

  useEffect(() => {
    fetchPlace();
  }, [reloadPlace, data.search, data.page, data.per_page]); // eslint-disable-line

  const fetchPlace = async () => {
    setData((prev) => ({ ...prev, loading: true }));

    const { data: response, error } = await placesApi(
      data.search,
      data.page,
      data.per_page
    );
    if (response) {
      response.data = response.data.map((value) => ({
        ...value,
        key: value.id,
      }));
      setData((prev) => ({ ...prev, ...response, loading: false }));
    } else {
      showError(error!.message);
      setData((prev) => ({ ...prev, loading: false }));
    }
  };

  const handleSearch = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    setData((prev) => ({ ...prev, search: value ?? "" }));
  };

  const handlePageChange = ({ current }: TablePaginationConfig) => {
    if (current) setData((prev) => ({ ...prev, page: current }));
  };

  return {
    data,
    handlePageChange,
    handleSearch,
  };
}
